import React, { useEffect, useRef, useState } from "react";
import Layout16 from "../libs/Layout16.json";
import mobLayout4 from "../libs/mobLayout4.json";
import './styles.css';

var DetectRTC = require('detectrtc');

const CombinedViewVideo = (props) => {
    let { selfVideo, peers, consumers, headless } = props;
    console.log(peers, consumers, headless);
    const [hostVideo, sethostVideo] = useState(null);
    const selfRef = useRef(null);
    const peerRefs = {};
    let hostpeer = null;
    hostpeer = headless ? peers.find(obj => obj.roleType === "Host") : null;
    peers = headless && hostpeer ? peers.filter(peer => peer.roleType !== "Host") : peers;
    console.log("this is hostid", hostpeer);

    useEffect(() => {
        if (selfRef && selfRef.current && selfVideo && !headless) {
            selfRef.current.srcObject = selfVideo;
        }
        if (selfRef && selfRef.current && hostVideo) {
            selfRef.current.srcObject = hostVideo;
        }

    }, [selfVideo, hostVideo, selfRef]);

    useEffect(() => {

        if (consumers && consumers.length > 0) {
            consumers.forEach(consumer => {
                if (consumer.kind === "video" && consumer.source === "webcam" && peerRefs[consumer.peerId]) {
                    const stream = new MediaStream();
                    stream.addTrack(consumer.track);
                    peerRefs[consumer.peerId].srcObject = stream;
                }
                if (headless && consumer.kind === "video" && consumer.source === "webcam" && consumer.peerId === hostpeer.id) {
                    const stream = new MediaStream();
                    stream.addTrack(consumer.track);
                    sethostVideo(stream);
                }
            });
        }
    }, [consumers]);

    const ratio = 16 / 9;
    const totalElements = peers.length + 1;
    let objLayout, _h, gap, tgap;
    const aspectRatio_H = 1 / ratio; //9/16;
    const windowHeight = (document.fullscreen) ? window.innerHeight : window.innerHeight - 88;
    const windowWidth = windowHeight * ratio;//16/9;
    // const fixWidth = (window.innerWidth - windowWidth) / 2;
    const hieghtFix = 0;
    let style_obj = {};
    if (DetectRTC.isMobileDevice && window.innerHeight > window.innerWidth) {
        objLayout = mobLayout4[totalElements - 1];
        style_obj = {
            left: objLayout.region[0].left,
            top: objLayout.region[0].top,
            height: objLayout.region[0].height,
            width: objLayout.region[0].width,
            position: 'absolute', borderRadius: 0, border: 'none', backgroundColor: '#000'
        }
    } else {
        objLayout = Layout16[totalElements - 1];
        _h = (windowWidth * objLayout.region[0].relativeSize) * aspectRatio_H;
        gap = (windowWidth * objLayout.region[0].gap) * 0.5;
        tgap = (windowHeight - ((windowWidth * objLayout.region[0].tgap) * aspectRatio_H)) / 2;
        style_obj = {
            left: windowWidth * objLayout.region[0].left + gap + 'px',
            top: ((_h * objLayout.region[0].top) + tgap) - hieghtFix + 'px',
            height: _h + 'px',
            width: (windowWidth * objLayout.region[0].relativeSize) + 'px',
            position: "absolute", overflow: "hidden", backgroundColor: "#000"
        }
    }
    return <>
        {
            <div id={'self'} style={style_obj} className="confVideoBox btmsmall">
                <div id={`img-self_id`} className={(!hostVideo && !selfVideo) && "zIndexPositive"}>
                    <span></span>
                    <img src="/images/icons/profile-outline.png" alt="Profile icon" />
                </div>
                <div className="confNameBox">
                    <small>{hostpeer ? hostpeer.displayName : "you"}</small>
                </div>
                {
                    (hostVideo || selfVideo) && <video ref={selfRef} className="videoElm" autoPlay playsInline controls={false} muted />
                }
            </div>
        }
        {peers.map((peer, i) => {
            if (DetectRTC.isMobileDevice && window.innerHeight > window.innerWidth) {
                style_obj = {
                    left: objLayout.region[i + 1].left,
                    top: objLayout.region[i + 1].top,
                    height: objLayout.region[i + 1].height,
                    width: objLayout.region[i + 1].width,
                    position: 'absolute', borderRadius: 0, border: 'none', backgroundColor: '#000'
                }
            } else {
                _h = (windowWidth * objLayout.region[i + 1].relativeSize) * aspectRatio_H;
                gap = (windowWidth * objLayout.region[i + 1].gap) * 0.5;
                tgap = (windowHeight - ((windowWidth * objLayout.region[i + 1].tgap) * aspectRatio_H)) / 2;
                style_obj = {
                    left: windowWidth * objLayout.region[i + 1].left + gap + 'px',
                    top: ((_h * objLayout.region[i + 1].top) + tgap) - hieghtFix + 'px',
                    height: _h + 'px',
                    width: (windowWidth * objLayout.region[i + 1].relativeSize) + 'px',
                    position: "absolute", overflow: "hidden", backgroundColor: "#000"
                }
            }
            return <div key={peer.id} id={peer.id} style={style_obj} className="confVideoBox btmsmall">
                {consumers.filter((each) => each.peerId === peer.id && each.kind === 'video').length === 0 &&
                    <div id={`img-${peer.id}`} className="videoDisableAvatar">
                        <span></span>
                        <img src="/images/icons/profile-outline.png" alt="Profile icon1" />
                    </div>
                }
                <div className="confNameBox">
                    <small>{peer.displayName}</small>
                </div>
                {
                    <video className={consumers.filter((each) => each.peerId === peer.id && each.kind === 'video').length === 0 && "zIndexNegative"} key={peer.id} ref={node => { peerRefs[peer.id] = node; }} id={peer.id} muted playsInline autoPlay />}

            </div>
        })}
    </>
};

export default CombinedViewVideo;